// extracted by mini-css-extract-plugin
module.exports = {"title":"recommendation-section_title__6_RFn","titleBox":"recommendation-section_titleBox__XYoUN"};